import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { R as y, b as w, P as N, O as D, C as O, T as b, D as k, a as t } from "../../../index-BBP4uN5S.js";
import { c as d } from "../../../clsx-OuTLNxxd.js";
import { B as s } from "../../../button.types-CVnZbzdO.js";
import { C as I } from "../../../callout-CWj10919.js";
import { I as j } from "../../../icon-D_HK7aSj.js";
import "../icon/iconsList.js";
const B = "_icon_1xc6d_79", i = {
  "alert-dialog-overlay": "_alert-dialog-overlay_1xc6d_29",
  "dialog-overlay-show": "_dialog-overlay-show_1xc6d_1",
  "alert-dialog": "_alert-dialog_1xc6d_29",
  "dialog-content-show": "_dialog-content-show_1xc6d_1",
  "alert-dialog-title": "_alert-dialog-title_1xc6d_66",
  icon: B,
  "icon-success": "_icon-success_1xc6d_82",
  "icon-error": "_icon-error_1xc6d_85",
  "icon-warning": "_icon-warning_1xc6d_88",
  "icon-info": "_icon-info_1xc6d_91",
  "alert-dialog-description": "_alert-dialog-description_1xc6d_95",
  "alert-dialog-content": "_alert-dialog-content_1xc6d_99",
  "callout-container": "_callout-container_1xc6d_104",
  "alert-dialog-actions": "_alert-dialog-actions_1xc6d_108",
  "dialog-content-slide-up": "_dialog-content-slide-up_1xc6d_1"
}, R = {
  success: "verification-check-regular",
  error: "error-regular",
  warning: "warning-regular",
  info: "information-circle-regular"
};
function q({
  children: _,
  dialogTriggerNode: g,
  title: h,
  confirmActionText: m,
  dismissActionText: n,
  onDismissAction: c,
  onConfirmAction: u,
  confirmActionColor: x = "primary",
  iconStatus: l,
  calloutProps: r,
  isOpen: p,
  confirmActionIsLoading: f,
  setIsOpen: v
}) {
  const C = d(i["alert-dialog"]);
  return /* @__PURE__ */ a(y, { open: p, onOpenChange: v, children: [
    /* @__PURE__ */ e(w, { asChild: !0, children: g }),
    /* @__PURE__ */ a(N, { children: [
      /* @__PURE__ */ e(D, { className: i["alert-dialog-overlay"] }),
      /* @__PURE__ */ a(
        O,
        {
          "aria-describedby": void 0,
          className: C,
          onInteractOutside: (o) => o.preventDefault(),
          onPointerDownOutside: (o) => o.preventDefault(),
          onEscapeKeyDown: (o) => o.preventDefault(),
          children: [
            /* @__PURE__ */ a(b, { className: i["alert-dialog-title"], children: [
              l && /* @__PURE__ */ e("div", { className: d(i.icon, i[`icon-${l}`]), children: /* @__PURE__ */ e(j, { color: "inherit", name: R[l], size: "7xl" }) }),
              h
            ] }),
            /* @__PURE__ */ e(k, { asChild: !0, children: /* @__PURE__ */ a("div", { className: i["alert-dialog-description"], children: [
              /* @__PURE__ */ e("div", { className: i["alert-dialog-content"], children: _ }),
              (r == null ? void 0 : r.children) && /* @__PURE__ */ e("div", { className: i["callout-container"], children: /* @__PURE__ */ e(I, { ...r }) })
            ] }) }),
            /* @__PURE__ */ a("div", { className: i["alert-dialog-actions"], children: [
              n && c && /* @__PURE__ */ e(t, { asChild: !0, children: /* @__PURE__ */ e(s, { color: "tertiary", onClick: c, children: n }) }),
              /* @__PURE__ */ e(t, { asChild: !0, children: /* @__PURE__ */ e(s, { isLoading: f, color: x, onClick: u, children: m }) })
            ] })
          ]
        }
      )
    ] })
  ] });
}
export {
  q as AlertDialog
};
